import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const MobileBannersPage = loadable(
  async () => import("~/features/mobile-banners/pages/MobileBannersPage"),
  { fallback: <></> },
)

export const mobileBannerRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.mobileBanners,
    element: <MobileBannersPage />,
  },
]
